import { createRootRoute, HeadContent, Outlet } from '@tanstack/react-router';
import { GameShell } from 'components/GameShell';
import { appConfig } from 'engine/appConfig';
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
// import favicon from '@platformComponents/favicon.ico';

const RouteComponent = () => {
	return (
		<>
			<HeadContent />
			<GameShell>
				<Outlet />
			</GameShell>
			{/* <TanStackRouterDevtools /> */}
		</>
	);
};

export const Route = createRootRoute({
	component: RouteComponent,
	head: () => ({
		meta: [
			{
				title: `${appConfig.title} ${import.meta.env.DEV ? ' dev' : ''}`,
			},
		],
		links: [
			{
				rel: 'icon',
				href: '/favicon.ico',
			},
		],
	}),
});
